// store/slices/appSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  isLoading: boolean;
  isOnline: boolean;
  error: string | null;
  notifications: any[];
}

const initialState: AppState = {
  isLoading: false,
  isOnline: navigator.onLine,
  error: null,
  notifications: [],
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    addNotification: (state, action: PayloadAction<any>) => {
      state.notifications.push(action.payload);
    },
  },
});

export const { setLoading, setOnlineStatus, setError, addNotification } = appSlice.actions;
export default appSlice.reducer;